import { Notification } from 'element-ui';

// Single notification entry point for the whole app: Element top-right edge toasts (nothing covered, no layout pushed).
// Do not call Message/Notification directly in components, or duration, position and styling will drift again.
const BASE = {
    position: 'top-right',
    offset: 76,          // sits below the fixed top bar
    showClose: true,
};

const make = (type, duration) => (message, options = {}) => {
    const text = String(message ?? '').trim();
    if (!text) return null;
    const { title = '', ...rest } = options;
    return Notification({
        ...BASE,
        type,
        title,
        message: text,
        duration,
        customClass: `app-notice is-${type}`,
        ...rest,
    });
};

export const notify = {
    success: make('success', 3500),
    info: make('info', 5000),
    warning: make('warning', 8000),
    error: make('error', 10000),
    clear: () => Notification.closeAll(),
};

export default notify;